<template>
    <div>
        <!-- 탑버튼 스크롤 -->
        <div v-if="showScrollButtons" class="hp_scrollBtn"> <!-- scroll-buttons -->
            <button @click="scrollToTop">
            <img
                :src="require(`@/assets/images/etc/btn_top.png`)"
                alt="화살표"/>
            </button>
        </div>

        <!-- 좌측 챗봇 배너 -->
        <div class="hp_leftFloatBanner">
            <a href="https://pf.kakao.com/_xbHxbnj" target="_blank">
                <img src="../../../assets/images/etc/btn_chatbot.png" alt="챗봇">
            </a>
            <!-- <a href="/">
                <img src="../../../assets/images/etc/btn_naver.png" alt="네이버문의">
            </a> -->
            <a href="/TravelProduct?departureConfirmed=1">
                <img src="../../../assets/images/etc/btn_fixtour.png" alt="출발확정여행">
            </a>
            <a href="https://blog.naver.com/happy_train" target="_blank" style="margin-top:65px;">
                <img src="../../../assets/images/etc/btn_blog.jpg" alt="네이버 블로그">
            </a>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  methods: {
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    scrollToBottom () {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      })
    }
  },
  setup () {
    const showScrollButtons = ref(false)

    const checkScroll = () => {
      showScrollButtons.value = window.scrollY > 0 // 최상단이 아닐 때만 버튼을 표시
    }

    onMounted(() => {
      window.addEventListener('scroll', checkScroll)
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', checkScroll)
    })

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    const scrollToBottom = () => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      })
    }

    return {
      showScrollButtons,
      scrollToTop,
      scrollToBottom
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Section/Scroll.vue